import { ModalDialog } from '../../job-roles/components/ModalDialog';
import type { DashboardDetail } from '../dashboardTypes';
import { formatMoney, recordReference } from '../format';

/** Shown only after the server has saved the record and answered. Records history only: nothing was sent, debited or paid. */
export function OutsidePaymentSuccessDialog({ detail, onClose }: { detail: DashboardDetail; onClose: () => void }) {
  const record = detail.outsideRecord;
  return (
    <ModalDialog
      title="Outside Payment Recorded" size="sm" role="alertdialog" onClose={onClose}
      footer={<button type="button" className="jr-btn jr-btn--primary" data-autofocus onClick={onClose}>Done</button>}
    >
      <p className="tpd-success-mark" aria-hidden="true">✓</p>
      <p>The outside payment of <strong>{formatMoney(record?.amount ?? detail.row.amount)}</strong> was recorded. The payment is now <strong>Paid Outside Escochex</strong>.</p>
      {record && <p>Record reference: <strong title={record.id} data-testid="record-reference">{recordReference(record.id)}</strong></p>}
      <p className="tpd-muted">This is a record only. No money was moved and nothing was sent to the agency.</p>
    </ModalDialog>
  );
}
